import type { HtmlType } from '../../types.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { StaticEntityBlock } from './static-entity-block.js'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'

@jsonClass('ToggleGroupBlock')
export class ToggleGroupBlock extends StaticEntityBlock {
	constructor(init?: Partial<ToggleGroupBlock>) {
		super()
		this.appearance = undefined
		this.init(init)
	}

	producePreview(): HtmlType {
		return this.exampleText || `A | B | C`
	}

	getEditorCategory(): string {
		return 'Additional Form Fields'
	}

	canHaveAppearance() {
		return false
	}
}
